import { render, staticRenderFns } from "./wallets.vue?vue&type=template&id=7e4d32a2"
import script from "./wallets.vue?vue&type=script&lang=js"
export * from "./wallets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports